export default function PlanningCommissionMembership() {
    return (
<div>
 <h4>Members</h4>
                <hr/>
                <p>
                  <b>Peter Berkin</b>
                  <br/>
                  Term Expires: December 2027
                </p>
                <p>
                  <b>Don Diretto</b>
                  <br/>
                  Term Expires: December 2028
                </p>
                <p>
                  <b>Cheri Vogel</b>
                  <br/>
                  Term Expires: December 2028
                </p>
                <p>
                  <b>Dennis Kinny</b>
                  <br/>
                  Term Expires: December 2029
                </p>
                <p>
                  <b>Andrew Lubin</b>
                  <br/>
                  Term Expires: December 2029
                </p>

</div>
    )
}
